import { ComponentProps, useCallback } from 'react'

import CopyIcon from '@/assets/icons/icon-copy.svg'
import { classNames } from '@/utils/helpers'

import { useToast } from './toast'

interface CopyTextButtonProps extends ComponentProps<'button'> {
  text: string
  toastMessage?: string
}

export const CopyTextButton = ({
  text,
  toastMessage,
  className,
  ...props
}: CopyTextButtonProps) => {
  const toast = useToast()

  const copyText = useCallback(() => {
    navigator.clipboard.writeText(text)

    if (toastMessage) {
      toast.success(toastMessage)
    }
  }, [text, toastMessage, toast])

  return (
    <button onClick={copyText}>
      <CopyIcon
        className={classNames(
          'w-6 hover:cursor-pointer text-primary-500 hover:text-primary-400',
          className,
        )}
      />
    </button>
  )
}
